import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { requireLoggedIn, requireLogout, requireSuperadmin } from './services/auth/auth.guard';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'videos/my-videos',
    pathMatch: 'full',
  },
  {
    path: 'login',
    loadComponent: () => import('./pages/login/login.page').then((m) => m.LoginPage),
    canActivate: [requireLogout],
  },
  {
    path: 'payment-confirmation',
    loadComponent: () => import('./pages/payment-confirmation/payment-confirmation.page').then((m) => m.PaymentConfirmationPage),
  },
  {
    path: 'videos',
    loadChildren: () => import('./pages/videos-module/videos.module').then((m) => m.VideosModule),
    canActivate: [requireLoggedIn],
  },
  {
    path: 'configuration',
    loadChildren: () => import('./pages/configuration-module/configuration-module.module').then((m) => m.ConfigurationModule),
    canActivate: [requireLoggedIn],
  },
  {
    path: 'superadmin',
    loadChildren: () => import('./pages/superadmin-module/superadmin.module').then((m) => m.SuperadminModule),
    canActivate: [requireSuperadmin],
  },
  { path: '**', redirectTo: '' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
